module.exports = __webpack_public_path__ + "img/9.305b3bbf.jpg";